import React, {useState} from 'react';
import { useSelector, useDispatch } from "react-redux"; 

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tooltip from '@material-ui/core/Tooltip';
import { lightBlue } from '@material-ui/core/colors'; 
import Grid from '@material-ui/core/Grid';

import SingleSelect from '../singleSelect/singleSelect';
import SingleSelectPlain from '../singleSelectPlain/singleSelectPlain';
import MultiSelectWithAllOption from '../multiSelectWithAllOption/multiSelectWithAllOption';
import MultiSelectWithAllOptionPlain from '../multiSelectWithAllOptionPlain/multiSelectWithAllOptionPlain';

import { getFilteredMpReports } from '../../redux/actions/mpReports';
import { getFilteredMpDetails, getFilteredClientsGoFromMpDetails, getFilteredCitiesFromMpDetails, getFilteredUnitTypesFromMpDetails} from '../../redux/actions/mpDetails';
import { setTheFilter} from '../../redux/actions/shared';

import {_baseApiUrl} from '../../redux/constants';
import {getMonthsList, cityNameToId} from '../../utils/shared';


const useStyles = makeStyles((theme) => ({  
    root: {
      display: 'flex',
      flexDirection: 'row', 
      fleWrap: 'nowrap',
    },      
    success: {
        flexBasis: '75%',
        padding: '14px;',
        marginRight: '0px;',
        color: '#fff',
        // marginBottom: '10px;',
    },
    export: {
      color: 'black',
    },
    cancel: {
        flexBasis: '25%',
        padding: '14px;',
        color: '#fff',
        // backgroundColor: theme.palette.secondary.main,
    },
    additional: {
        flexBasis: '75%',
        padding: '14px;',
        backgroundColor: lightBlue[700],
        color: '#fff',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(2),
        minWidth: 120,
    },
    formcontrol: {
      paddingLeft: '14px;'
    },
    paper: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      listStyle: 'none',
      padding: theme.spacing(0.5),
      marginBottom: '20px;',
    },
    checkbox: {
      visibility: 'visible',
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'white',
      },
    },
    title: {
      padding: '10px;',
      paddingLeft: '24px;',
    },
    dialogcontent: {
      padding: '8px 24px 24px 24px',
    },
    dialogcontainer: {
      marginBottom: '10px',
    },

  }));

  function makeClientGoType(item){
    return {
      id: item.ctg_id,
      united: item.ctg_name,
    }
  }



export default function MaketsDialog3() {
  const classes = useStyles();
  
  const { unitTypes } = useSelector(state => state.unitTypes);
  const { clientsTypesGo } = useSelector(state => state.clientsTypesGo);
  const { filteredMpReports } = useSelector(state => state.mpReports);
  const { allCities, filteredClientsGoFromMpDetails, filteredCities, filteredUnitTypes } = useSelector(state => state.mpDetails);
  
  const {user_role, user_permissions} = useSelector(state => state.users);

  const dispatch = useDispatch();
  
  const [open, setOpen] = useState(false);
  
  const [month, setMonth] = useState('');
  const [mpr_id, setMprId] = useState([]);              // mp_reports  
  const [ctg_id, setClientsTypesGoId] = useState(); 
  const [clientGo, setClientGo] = useState([]);
  const [mpd_city, setMpdCity] = useState([]);          // mp_details
  const [mpd_unit_type, setMpdUnitType] = useState([]); // mp_details
  
  // const [mpd_mp_id, setMpdMpId] = useState([]);      // monitoring_projects 
  
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getFilter = function(dtoObj, property, action){
    return function(newValue){
      dtoObj[property] = newValue;
      console.log('obj', dtoObj);
      dispatch(action(dtoObj));
    }
  };

  // const cities = allCities.map(item => item.mpd_city);

  const loadPhotos = () => {
    const filter = {
      ctg_id: [].concat(ctg_id),
      mprd_client_go: clientGo.length === filteredClientsGoFromMpDetails.length ? [] : clientGo,
      mpr_planned_date: [].concat(month),
      mpr_id: mpr_id,
      mpd_city: mpd_city,
      mpd_unit_type: mpd_unit_type,
    };

    dispatch(getFilteredMpDetails(filter));
    dispatch(setTheFilter(filter));

    handleClose();
  } 


  console.log('clientsTypesGo: ', clientsTypesGo);
  console.log('month: ', month);
  console.log('mpr_id: ', mpr_id);
  console.log('ctg_id: ', ctg_id);
  console.log('clientGo: ', clientGo);
  console.log('mpd_city: ', mpd_city);
  console.log('mpd_unit_type: ', mpd_unit_type);
  // console.log('cities: ', cities);
  console.log('unitTypes: ', unitTypes);
  console.log('allCities: ', allCities);
  console.log('filteredCities: ', filteredCities);
  // console.log('user_permissions.cities: ', user_permissions.cities);


  return (
    <div>
      <Grid container spacing={2} alignItems={'center'} className={classes.dialogcontainer}>

        <Grid item>
        <Tooltip title="Месяц -> Отчет -> Тип клиента (1) -> Клиент -> Город -> Тип констр.">
          <Button
              variant="contained"
              size="large"
              color="secondary" 
              className={classes.success}
              onClick={handleClickOpen}
          >
              Фильтр 3
          </Button>
          </Tooltip>
        </Grid>


        <Grid item>
        <Dialog disableBackdropClick disableEscapeKeyDown open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title" className={classes.title}>Фильтр</DialogTitle>
          
          <DialogContent className={classes.dialogcontent}>

              <form className={classes.container}>
                <Grid container spacing={1} display="flex" direction="column"  wrap="nowrap" alignItems="baseline">

                <Grid item>
                  <SingleSelectPlain
                      label={'Месяц'}
                      style={{
                        width: 550, 
                      }}
                      items={user_role === 'Admin' ? getMonthsList(12) : getMonthsList(12).filter(item => user_permissions.months.includes(item))}
                      value={month}
                      selected={month}
                      setValue={setMonth} 
                      fn={getFilter(
                        {
                          mpr_planned_date: [],
                        },
                        'mpr_planned_date',
                        getFilteredMpReports,
                        dispatch,
                      )}
                      array={true}
                    />              
                  </Grid>

                  {filteredMpReports.length>0 &&
                  <Grid item>
                          <MultiSelectWithAllOptionPlain
                              style={{
                                width: 550,
                              }}
                              label={'Отчеты мониторинга'}
                              items={user_role === 'Admin' ? filteredMpReports : filteredMpReports.filter(item => user_permissions.reports.includes(item))}
                              value={mpr_id}
                              selected={mpr_id}
                              onChange={setMprId}
                              // fn={getFilter(
                              //   {                          
                              //     mpr_planned_date: [].concat(month),
                              //     mpr_id: [],
                              //   },
                              //   'mpr_id',
                              //   getFilteredClientsGoFromMpDetails,
                              //   dispatch,
                              // )} 
                          />
                  </Grid>}           
                  
                  
                  {mpr_id.length>0 &&
                  <Grid item>
                    <SingleSelect
                      label={'Client_Types_Go'}
                      style={{
                        width: 550,
                      }}
                      items={clientsTypesGo}
                      value={ctg_id}
                      selected={ctg_id}
                      setValue={setClientsTypesGoId} 
                      fn={getFilter(
                        {
                          mpr_planned_date: [].concat(month),
                          mpr_id: mpr_id,
                          ctg_id: [],
                        },
                        'ctg_id',
                        getFilteredClientsGoFromMpDetails,
                        dispatch,
                      )}
                      array={true}
                      id={"ctg_id"}
                      name={"ctg_name"}
                    />                  
                  </Grid>
                  }

                  {filteredClientsGoFromMpDetails.length>0 && 
                  <Grid item>
                    <MultiSelectWithAllOption
                      style={{
                        width: 550,
                      }}
                      label={'Client_Go'}
                      items={filteredClientsGoFromMpDetails}
                      limitTags={5}
                      value={clientGo}
                      selected={clientGo}
                      onChange={setClientGo} 
                      fn={getFilter(
                        {
                          mpr_planned_date: [].concat(month),
                          mpr_id: mpr_id,
                          ctg_id: [].concat(ctg_id),
                          mprd_client_go: [],
                        },
                        'mprd_client_go',
                        getFilteredCitiesFromMpDetails,
                        dispatch
                      )}
                    />
                  </Grid>}                  

                  {clientGo.length>0 && filteredCities.length>0 &&
                  <Grid item>
                          <MultiSelectWithAllOptionPlain
                              style={{
                                width: 550,
                              }}
                              label={'Город'}
                              items={user_role === 'Admin' ? filteredCities : filteredCities.filter(item => user_permissions.cities.includes(cityNameToId(item, allCities)))}
                              // items={user_role === 'Admin' ? filteredCities : filteredCities.filter(item => user_permissions.cities.includes(cityNameToId(item, allCities)))} // mpd_city vs. mpd_city_id
                              value={mpd_city}
                              selected={mpd_city}
                              onChange={setMpdCity}
                              fn={getFilter(
                                {
                                  mpr_planned_date: [].concat(month),
                                  mpr_id: mpr_id,
                                  ctg_id: [].concat(ctg_id),
                                  mprd_client_go: clientGo.length === filteredClientsGoFromMpDetails.length ? [] : clientGo, 
                                  mpd_city: [],                                
                                },
                                'mpd_city',
                                getFilteredUnitTypesFromMpDetails
                              )}
                          />
                  </Grid>}

                  {mpd_city.length>0 && filteredUnitTypes.length>0 && 
                  <Grid item>
                    <MultiSelectWithAllOptionPlain
                        style={{
                          width: 550,
                        }} 
                        label={'Типы конструкций'}
                        items={filteredUnitTypes}
                        value={mpd_unit_type}
                        selected={mpd_unit_type}
                        onChange={setMpdUnitType} 
                    />
                  </Grid>}

                
                </Grid>
              </form>
          </DialogContent>
        

          
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Отмена
            </Button>

            {mpd_unit_type.length>0 &&
            <Button 
              color="secondary"
              onClick={loadPhotos}
            >
              Загрузить фотографии
            </Button>}
            
          </DialogActions>
        </Dialog>
      </Grid>

    </Grid>
      
    </div>
  );
}